import {Facebook} from '../sdk/facebook.sdk';

export class FacebookConfig implements Facebook.InitParams {
    appId = '369180953777515';
    autoLogAppEvents = true;
    xfbml = false;
    version = 'v3.3';
}
